module.exports = __webpack_public_path__ + "static/media/eight.334c2283.svg";